/**
 * Creado por Norte70
 *
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 27/10/2020
 */
const ordersRequestModel = () => {
    return {
        data:{
            page: null,
            status: null,
            limit: null
        },
        session_user: 1,
        invited: 0,
    }
}

export default ordersRequestModel;